export var LESYM = Symbol["for"]("__le__");
export var LE_PACK_SYM = Symbol["for"]("__le__pack__");